import React, { useEffect } from "react";

const Alert = ({ type, msg, removeAlert, items }) => {
  //triggered on the rendering of the component of alert, and makes it disappear in 3
  // addding list as dependency allows for smooth 3 second wait on every single alert
  useEffect(() => {
    const timeout = setTimeout(() => {
      removeAlert();
    }, 3000);

    // cleanup of setTimeout
    return () => {
      clearTimeout(timeout);
    };
  }, [items]);
  return <p className={`alert alert-${type}`}>{msg}</p>;
};

export default Alert;
